module.exports = __webpack_public_path__ + "static/media/logo.7156ac82.svg";